import React from 'react';
import ReactDOM from "react-dom";
import MaterialTable from 'material-table';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

export default class VaccinationsDoctor extends React.Component {
  constructor(props) {
    super(props);
    this.theme = createMuiTheme({
      palette: {
        primary: {
          main: '#7cb342',
        },
        secondary: {
          main: '#4caf50',
        },
      },
    });

    this.state = {
      columns: [
        { title: 'Name', field: 'name'},
        { title: 'Dept Code', field: 'dept_code'},
        { title: 'Doctor Code', field: 'doctor_code', grouping: false },
        { title: 'Branch ID', field: 'branch_id' },
        { title: 'Phase', field: 'phase' },
        { title: 'Handled User', field: 'total_handled'},
      ],
      data: [],
      page: null,
      totalCount: null
    }

    this.tableRef = React.createRef();
  }

  assignDoctors(phase){
    new Promise((resolve, reject) => {
      const csrfToken = document.querySelector('[name=csrf-token]').content
      {
        return fetch(`/vaccinations/${this.props.vaccination_id}/assign_random_participants.json?phase=${phase}`, {
          method: 'POST',
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            'X-CSRF-Token': csrfToken
          }
        }).then(response => {
          return response.json()
        }).then(result => {
          console.log(result)
          alert(result.message)
          // this.tableRef.current && this.tableRef.current.onQueryChange()
          // Turbolinks.visit(result.redirect_url);
        })
      }
      resolve()
      
    });
  }

  render () {
    return (
      <MuiThemeProvider theme={this.theme}>
        <MaterialTable
          title="Doctors Vaccination"
          tableRef={this.tableRef}
          columns={this.state.columns}
          data={query =>
            new Promise((resolve, reject) => {
              let url = `/api/vaccinations/${this.props.vaccination_id}/doctors.json?`
              // console.log('params', query)
              url += 'per_page=' + query.pageSize
              url += '&q=' + query.search
              url += '&page=' + (query.page + 1)
              fetch(url)
                .then(response => response.json())
                .then(result => {
                  // console.log('row data', result.accounts.data)
                  resolve({
                    data: result.doctors,
                    page: result.pagination.page - 1,
                    totalCount: result.pagination.count,
                  })
                })
            })
          }
          editable={{
            onRowDelete: oldData =>
              new Promise((resolve, reject) => {
                const csrfToken = document.querySelector('[name=csrf-token]').content
                setTimeout(() => {
                  {
                    return fetch(`/api/vaccination_doctors/${oldData.id}`, {
                      method: 'DELETE',
                      headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        'X-CSRF-Token': csrfToken
                      }
                    }).then(response => {
                      return response.json()
                    }).then(result => {
                      console.log(result)
                      console.log('state data', this.state.data)
                      let data = this.state.data;
                      const index = data.indexOf(oldData);
                      data.splice(index, 1);
                      this.setState({ data }, () => resolve());
                    })
                  }
                  resolve()
                }, 400)
              }),
          }}

          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
            },
            {
              icon: 'backup',
              tooltip: 'Delegeta Doctors Phase One',
              isFreeAction: true,
              onClick: (event) => this.assignDoctors('phase_one')
            },
            {
              icon: 'backup',
              tooltip: 'Delegeta Doctors Phase two',
              isFreeAction: true,
              onClick: (event) => this.assignDoctors('phase_two')
            }
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 20, 30, 50, 100],
            exportButton: true,
            sorting: true,
            search: true,
            actionsColumnIndex: -1
            // grouping: true
            // tableLayout: 'fixed'

          }}
          onRowClick={(event, rowData) => Turbolinks.visit(rowData.url)}
        />
      </MuiThemeProvider>
    );
  }
}

